import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.breadcrumbs, (b) => {
    return (_openBlock(), _createElementBlock("span", _hoisted_1, [
      _createElementVNode("a", {
        class: _normalizeClass({'breadcrumb-item': true, 'active': b.Current}),
        onClick: b.Callback
      }, _toDisplayString(b.Name), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
    ]))
  }), 256 /* UNKEYED_FRAGMENT */))
}